import Select from 'react-select';
import floatToCurrency from '../../../../../../../../utils/floatToCurrency';
import FilterRadioButton from '../../../../../../../FilterRadioButtons';
import { SecondaryButton } from '../../../../../../../SecondaryButton';
import { SectionOptionType, TrajetosIda, TrajetosVolum } from '../../../../../../types';
import { ViewType } from '../../types';
import { Container, SummaryContainer } from './styles';

import { Dispatch, SetStateAction } from 'react';
import clock from '../../../../../../../../assets/images/icons/clock.svg';
import coins from '../../../../../../../../assets/images/icons/coins.svg';
import distance from '../../../../../../../../assets/images/icons/distance.svg';
import useThemeContext from '../../../../../../../../contexts/theme';
import { CustomStyle } from '../../../../../../../CustomSelectStyle';
import { CustomStyle as CustomStyleDarkTheme } from '../../../../../../../CustomSelectStyleDarkTheme';
import FormGroup from '../../../../../../../FormGroup';
import OpacityAnimation from '../../../../../../../OpacityAnimation';

interface IHeader {
  view: ViewType;
  handleViewChange: (view: ViewType) => void;
  selectedGoingRoute: TrajetosIda;
  selectedReturningRoute: TrajetosVolum;
  setChangeGoingOptionModalShow: Dispatch<SetStateAction<boolean>>;
  setChangeReturningOptionModalShow: Dispatch<SetStateAction<boolean>>;
  canShowTicketsTab: boolean;
  isConsultValid: boolean;
  handleSelectedSectionChange: (selectedSection: SectionOptionType) => void,
  sectionOptions: SectionOptionType[],
  selectedSection: SectionOptionType,
  isMultiRoute: boolean;
}

export default function Header({
  view,
  handleViewChange,
  selectedGoingRoute,
  selectedReturningRoute,
  setChangeGoingOptionModalShow,
  setChangeReturningOptionModalShow,
  canShowTicketsTab,
  isConsultValid,
  handleSelectedSectionChange,
  sectionOptions,
  selectedSection,
  isMultiRoute,
}: IHeader) {
  const { selectedTheme } = useThemeContext();

  return (
    <>
      <Container>
        <FilterRadioButton selected={view === 'going'} onClick={() => handleViewChange('going')}>
          {isMultiRoute ? 'Trechos do Trajeto' : 'Ida'}
        </FilterRadioButton>
        {!isMultiRoute && !!selectedReturningRoute?.codConsulta && (
          <FilterRadioButton selected={view === 'returning'} onClick={() => handleViewChange('returning')}>
            Volta
          </FilterRadioButton>
        )}
        {canShowTicketsTab && (
          <FilterRadioButton selected={view === 'tickets'} onClick={() => handleViewChange('tickets')}>
            Bilhetes
          </FilterRadioButton>
        )}
      </Container>

      {view === 'going' && (
        <OpacityAnimation delay={0.15}>
          {isMultiRoute && (
            <FormGroup padding={8}>
              <label htmlFor="contactName">Selecione o trecho</label>
              <Select
                value={selectedSection}
                options={sectionOptions}
                onChange={(gsct) => handleSelectedSectionChange(gsct as SectionOptionType)}
                placeholder="Selecionar etapa da ida"
                styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
                classNamePrefix="react-select"
                className="react-select-container"
              />
            </FormGroup>
          )}
          <SummaryContainer>
            <div>
              <img src={distance} alt="" className='primaryColor' />
              <span>{selectedGoingRoute.distanciaTotTj} m</span>
            </div>
            <div>
              <img src={clock} alt="" className='primaryColor' />
              <span>{selectedGoingRoute.tempoTotTj} min</span>
            </div>
            <div>
              <img src={coins} alt="" className='primaryColor' />
              <span>{floatToCurrency(selectedGoingRoute.valorVtTotal)}</span>
            </div>
          </SummaryContainer>
          {(canShowTicketsTab && isConsultValid) && (
            <Container>
              <SecondaryButton onClick={() => setChangeGoingOptionModalShow(true)}>
                {isMultiRoute ? 'Trocar Opção do Trecho' : 'Trocar Opção Ida'}
              </SecondaryButton>
            </Container>
          )}
        </OpacityAnimation>
      )}

      {view === 'returning' && (
        <OpacityAnimation delay={0.15}>
          {isMultiRoute && (
            <FormGroup padding={8}>
              <label htmlFor="contactName">Selecione o trecho</label>
              <Select
                value={selectedSection}
                options={sectionOptions}
                onChange={(gsct) => handleSelectedSectionChange(gsct as SectionOptionType)}
                placeholder="Selecionar etapa da ida"
                styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
                classNamePrefix="react-select"
                className="react-select-container"
              />
            </FormGroup>
          )}
          <SummaryContainer>
            <div>
              <img src={distance} alt="" className='primaryColor' />
              <span>{selectedReturningRoute.distanciaTotTj} m</span>
            </div>
            <div>
              <img src={clock} alt="" className='primaryColor' />
              <span>{selectedReturningRoute.tempoTotTj} min</span>
            </div>
            <div>
              <img src={coins} alt="" className='primaryColor' />
              <span>{floatToCurrency(selectedReturningRoute.valorVtTotal)}</span>
            </div>
          </SummaryContainer>
          {(canShowTicketsTab && isConsultValid) && (
            <Container>
              <SecondaryButton onClick={() => setChangeReturningOptionModalShow(true)}>
                {isMultiRoute ? 'Trocar Opção do Trecho' : 'Trocar Opção Volta'}
              </SecondaryButton>
            </Container>
          )}
        </OpacityAnimation>
      )}
    </>
  );
}
